import Checkbox, { checkboxProps } from './Checkbox';
import CheckboxGroup from './Group';
Checkbox.Group = CheckboxGroup;
/* istanbul ignore next */
Checkbox.install = function (app) {
    app.component(Checkbox.name, Checkbox);
    app.component(CheckboxGroup.name, CheckboxGroup);
    return app;
};
export { CheckboxGroup, checkboxProps };
export default Checkbox;
